var isApp = function () {
    return typeof navigator !== 'undefined' && !!navigator.userAgent.match(/(Mdi Native Shell|floridaapp|georgialotteryofficialapp)/);
};
export default isApp;
